import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table"; // Use react-bootstrap Table
import { useEffect, useState } from "react";
import axiosInstance from "../../../../hooks/axiosInstance";

export default function ViewCustomFixedPayHistory({
    showHistoryView,
    closeModal,
    refreshPage,
    invoice_code,
}) {
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleClose = () => {
        closeModal();
    };

    const formatAmount = (amount) => {
        if (amount !== undefined && amount !== null) {
            return new Intl.NumberFormat().format(amount);
        }
        return amount;
    };

    useEffect(() => {
        if (invoice_code) {
            axiosInstance
                .get(`/user/payment/fetch_fixed_custom_payment_history/${invoice_code}`)
                .then((response) => {
                    setPaymentHistory(response.data.data.payment_history.data);
                    setLoading(false);
                })
                .catch((error) => {
                    setError("Error fetching payment history.");
                    setLoading(false);
                });
        }
    }, [invoice_code]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
        });
    };

    if (loading) {
        return (
            <Modal show={showHistoryView} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Loading Payment History...</Modal.Title>
                </Modal.Header>
                <Modal.Body>Loading...</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    if (error) {
        return (
            <Modal show={showHistoryView} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>{error}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    const paymentTable = paymentHistory.length ? (
        <Table responsive="sm" striped bordered hover>
            <thead>
                <tr>
                    <th style={{ width: "5%" }}>S/N</th>
                    <th style={{ width: "45%" }}>Product Name</th>
                    <th style={{ width: "30%" }}>Payment Date</th>
                    <th style={{ width: "20%" }}>Amount Paid</th>
                </tr>
            </thead>
            <tbody>
                {paymentHistory.map((payment, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                            {payment.type === "custom"
                                ? payment.custom_product_name
                                : payment.product_name}
                        </td>
                        <td>{formatDate(payment.date_of_payment)}</td>
                        <td>{formatAmount(payment.amount_paid)}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    ) : (
        <p>No payment history available.</p>
    );

    return (
        <div className="ViewTransaction">
            <Modal show={showHistoryView} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Payment History</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>
                    {paymentTable}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        style={{ backgroundColor: "#c4281b", border: "none" }}
                        onClick={refreshPage}
                    >
                        Refresh
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}